module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consultTeacher"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType == 1),
      expression: "showType == 1"
    }],
    staticClass: "consultTeacherMain"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "TeacherList"
  }, _vm._l((_vm.teacherList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "teacherCell",
      on: {
        "click": function($event) {
          return _vm.toDetail(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "nameSpan"
    }, [_vm._v(_vm._s(item.wx_nick_name))]), _vm._v(" "), (item.unRead > 0) ? _c('span', {
      staticClass: "unRead"
    }, [_vm._v(_vm._s(item.unRead))]) : _vm._e()])
  }), 0), _vm._v(" "), _c('img', {
    staticClass: "closeBtn",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png"
    },
    on: {
      "click": _vm.closeBtnClicked
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType == 2),
      expression: "showType == 2"
    }],
    staticClass: "messageMain"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/jiantou_back.png"
    },
    on: {
      "click": _vm.backList
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.backList
    }
  }, [_vm._v("返回列表")])]), _vm._v(" "), _c('div', {
    staticClass: "messageBox",
    attrs: {
      "id": "messageBox"
    }
  }, _vm._l((_vm.messageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "messageCell"
    }, [_c('div', [_c('div', {
      staticClass: "messageHeader other"
    }, [_c('img', {
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.create_time))])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "content"
    }), _vm._v(" "), (item.pic_url) ? _c('div', {
      staticClass: "contentImg"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    })]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "inputBox"
  }, [_c('van-field', {
    staticClass: "inputField",
    attrs: {
      "placeholder": "说点什么..."
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendC2CMsg.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }), _vm._v(" "), _c('van-button', {
    staticClass: "sendBtn",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "touchstart": _vm.sendC2CMsg
    }
  }, [_vm._v("发送")])], 1), _vm._v(" "), _c('img', {
    staticClass: "closeBtn",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png"
    },
    on: {
      "click": _vm.closeBtnClicked
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("在线老师列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f42bad8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/ConsultTeacher/index.vue
// module id = 380
// module chunks = 0